<div class="tw-bg-white tw-w-full tw-px-5 tw-py-7 tw-font-body" [class.tw-mb-5]="!noBottomMargin" #container>
  <h1 class="tw-text-400 tw-font-lexend tw-mb-4" i18n="@@faqs">FAQs</h1>
  <div class="tw-mb-5">
    <div class="tw-w-full tw-flex tw-justify-center tw-items-center">
      @if (loading){
        <loading></loading>
      }
    </div>
    @for (qna of faqs; track qna; let i = $index) {
      <div class="tw-border-b tw-border-b-gray-100" [id]='"faq-"+i'>
        <div class="tw-py-3 tw-flex tw-items-center" style="flex-flow: wrap;" data-testid="faq-question" (click)="expandCollapse(i, container)">
          <div class="tw-w-[92%] tw-text-300 te-text-black" [innerHTML]='qna.get("question")'></div>
          <div class="tw-min-w-[8%] tw-text-right">
            <em class="cs-icon-arrow tw-align-middle tw-text-teal-600" style="transform: rotate(90deg)"></em>
          </div>
        </div>
        <div class="tw-hidden tw-border-t tw-border-t-gray-100 tw-py-2 tw-text-300 tw-text-gray-400" data-testid="faq-answer" [innerHTML]='qna.get("answer")'></div>
      </div>
    }
  </div>
  <h1 class="text-300 tw-font-semibold tw-text-teal-600 tw-underline" i18n="@@viewMore" (click)="viewAllFaqs()">View More</h1>
</div>
